import React, { Component } from 'react';
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip,CartesianGrid } from 'recharts';
// import { ResponsiveContainer, Line, LineChart, XAxis, YAxis, Tooltip } from 'recharts';
import { connect } from "react-redux";
import { getAktiviterDailerByAfid } from 'actions'
import {isEmpty,isUndefined} from 'lodash'
import moment from 'moment'
import IntlMessages from 'util/IntlMessages';
function mapStateToProps({auth,DashBoard,settings}) {
    const { authUser} = auth;
    const { AktiviterDailer,DashboardDialerFilterOption} = DashBoard;
    const { width } = settings;
    return {
        authUser,AktiviterDailer,width,DashboardDialerFilterOption
    };
}
function mapDispatchToProps(dispatch) {
    return {
        getAktiviterDailerByAfid: (Afid,userid,FilterOption) => dispatch(getAktiviterDailerByAfid(Afid,userid,FilterOption)),
        dispatch
    }
  }




/*


const data = [
    { name: "3 JUN", "Antal": 0 },
    { name: "6 JUN", "Antal": 5 },
    { name: "9 JUN", "Antal": 7 },
    { name: "12 JUN", "Antal": 11 },
    { name: "15 JUN", "Antal": 14 },
    { name: "18 JUN", "Antal": 15 },
    { name: "21 JUN", "Antal": 17 },
    { name: "24 JUN", "Antal": 20 },
    { name: "27 JUN", "Antal": 22 },
    { name: "30 JUN", "Antal": 24 },
];
*/
class Diagram extends Component {
state={
    AktiverKunder:0,
    DashboardDialerFilterOption:parseInt(this.props.Kontor) === 0?[]:[{Meta:"Kontor",Value:this.props.Kontor}],
    done: false
}
intervalID = null
componentDidMount=()=>{
    const Afid = this.props.Afid;
    
    this.props.getAktiviterDailerByAfid(Afid,undefined,this.state.DashboardDialerFilterOption).then(() => { 
        this.initiateInterval()
        this.setState({done: true})
     })          
}
initiateInterval () {
    clearInterval(this.intervalID);
    this.intervalID = null 
    this.intervalID = setInterval(
        () => {
            if(this.state.done === true){ 
                this.setState({done: false,})
                const Afid = this.props.Afid;
                this.props.getAktiviterDailerByAfid(Afid,undefined,this.state.DashboardDialerFilterOption).then(() => { 
                    this.initiateInterval()
                    this.setState({done: true})
                 })
            }
        },
        30000
    );
  }
componentDidUpdate=()=>{
   /* if(this.props.DashboardDialerFilterOption !== this.state.DashboardDialerFilterOption && !isEmpty(this.props.DashboardDialerFilterOption))
       {
            
           const Afid = this.props.Afid;
           this.props.getAktiviterDailerByAfid(Afid).then(() => { 
            this.initiateInterval()
            this.setState({done: true})
         }) 
           this.setState({
            DashboardDialerFilterOption:this.props.DashboardDialerFilterOption 
           }) 
       }*/
    }
componentWillUnmount() {
    clearInterval(this.intervalID);
    this.intervalID = null
}

    formatNumber=(number)=>{
        if(number > 1000000){
            return `${(number/1000).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$& ')}K`
        }else if(number >= 1000){
          return `${(number/1000).toFixed(0)}K`
      }else{
        return number
      }
      }
    render() {
    return (
        <div>
            <ResponsiveContainer width="95%" height={this.props.DsHeight}>
                <AreaChart data={
                    isEmpty(this.props.AktiviterDailer)?[]:
                    this.props.AktiviterDailer}
                    margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                    <XAxis stroke="#ffffff66" tick={{ fill: 'white',fontSize: 10 }} dataKey="name"  />
                    <YAxis stroke="#ffffff66" tick={{ fill: 'white' }} type="number" domain={[0, 1000]} />
                    <CartesianGrid vertical={false} strokeDasharray="0" stroke="#44D1C24D" />
                    <Tooltip cursor={{ stroke: '#0c969c', strokeWidth: 1, fill: "#0c969c" }} 
                            labelStyle={{ color: "#075A5F" }}
                            itemStyle={{ color: "#075A5F" }}/>
                    <Area type="monotone" name={<IntlMessages id="Table.Quantity"/>}  dataKey="Antal" strokeWidth={2} stroke="#44D1C2" fill="#44D1C24D" />
                </AreaChart>
                {/* <LineChart data={
                    isEmpty(this.props.AktiviterDailer)?[]:
                    this.props.AktiviterDailer
                }
                    margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                    <XAxis tick={{ fill: 'white',fontSize: 10 }} dataKey="name"  />
                    <YAxis tick={{ fill: 'white' }} type="number" domain={[0, 1000]} />
                    <Tooltip cursor={{ stroke: '#0c969c', strokeWidth: 1, fill: "#0c969c" }} />
                    <Line type="monotone" dataKey="Antal" stroke="#44D1C2" />
                </LineChart> */}
            </ResponsiveContainer >
        </div >
    );
}
};


export default connect(mapStateToProps,mapDispatchToProps)(Diagram);
